import { Component, Input, OnInit } from "@angular/core";
import { MatChipInputEvent } from "@angular/material/chips";

export interface Fruit {
	name: string;
}

@Component({
	selector: "app-chips",
	templateUrl: "./chips.component.html"
})
export class ChipsComponent implements OnInit {
	@Input() fruits: Fruit[];
	selectable = true;
	removable = true;

	constructor() {}

	ngOnInit() {}

	add(event: MatChipInputEvent): void {
		const input = event.input;
		const value = event.value;

		// Add our fruit
		if ((value || "").trim()) {
			this.fruits.push({ name: value.trim() });
		}

		// Reset the input value
		if (input) {
			input.value = "";
		}
	}

	remove(fruit: Fruit): void {
		const index = this.fruits.indexOf(fruit);

		if (index >= 0) {
			this.fruits.splice(index, 1);
		}
	}
}
